import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../../contexts/AuthContext';
import { OrganizationProvider } from '../../contexts/OrganizationContext';
import { ToastProvider } from '../../contexts/ToastContext';
import { MunicipalitiesProvider } from '../../contexts/MunicipalitiesContext';

interface AppProvidersProps {
  children: React.ReactNode;
}

/**
 * AppProviders - Composition of all application-level context providers
 *
 * Provider stack (outside to inside):
 * 1. BrowserRouter - React Router routing
 * 2. AuthProvider - Authentication state
 * 3. OrganizationProvider - Multi-tenant organization management
 * 4. ToastProvider - Toast notification system
 * 5. MunicipalitiesProvider - Shared municipalities data
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OrganizationProvider>
          <ToastProvider>
            <MunicipalitiesProvider>
              {children}
            </MunicipalitiesProvider>
          </ToastProvider>
        </OrganizationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
